const timelineEvents = [
  {
    year: '1953',
    title: '《电影检查条例》颁布',
    description: '香港政府颁布首部电影检查法规，建立审查制度，所有公映影片须经审查批准。',
  },
  {
    year: '1986',
    title: '行业改革呼声高涨',
    description: '香港电影导演会等组织联合呼吁以分级制度取代审查制度，获得社会广泛支持。',
  },
  {
    year: '1988',
    title: '三级制正式实施',
    description: '11月10日，《电影检查条例》修订生效，确立第I级、第II级、第III级三级分类体系。',
  },
  {
    year: '1991',
    title: '票房巅峰纪录诞生',
    description: '《玉蒲团之偷情宝鉴》以超1800万港元票房刷新三级片历史纪录，至今未被打破。',
  },
  {
    year: '1995',
    title: '第II级细分改革',
    description: '第II级进一步细分为IIA（儿童不宜）和IIB（青少年及儿童不宜），分级体系更加精细化。',
  },
  {
    year: '1997',
    title: '回归与市场转型',
    description: '香港回归后，三级片市场面临VCD普及、金融危机等多重冲击，产业格局开始转型。',
  },
];

export default function TimelineSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            影史大事记
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm">
            香港电影分级制度与三级片发展的关键历史节点一览
          </p>
        </div>

        <div className="relative">
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-background-300 -translate-x-1/2"></div>

          <div className="space-y-8">
            {timelineEvents.map((event, index) => (
              <div
                key={event.year}
                className={`relative flex flex-col md:flex-row gap-4 md:gap-8 ${
                  index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                <div className={`flex-1 ${index % 2 === 0 ? 'md:text-right' : 'md:text-left'}`}>
                  <div className={`p-5 rounded-lg bg-background-100 border border-background-200/70 ${
                    index % 2 === 0 ? 'md:mr-8' : 'md:ml-8'
                  }`}>
                    <h3 className="font-heading text-lg font-bold text-foreground-900 mb-1">
                      {event.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {event.description}
                    </p>
                  </div>
                </div>

                <div className="hidden md:flex flex-col items-center flex-shrink-0">
                  <div className="w-10 h-10 rounded-full bg-accent-500 text-background-50 flex items-center justify-center font-heading font-bold text-sm">
                    {event.year}
                  </div>
                </div>

                <div className="flex-1 hidden md:block"></div>

                <div className="md:hidden flex items-center gap-3 mb-2">
                  <div className="w-8 h-8 rounded-full bg-accent-500 text-background-50 flex items-center justify-center font-heading font-bold text-xs flex-shrink-0">
                    {event.year.slice(2)}
                  </div>
                  <span className="text-sm text-foreground-500">{event.year}年</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}